import { FormGroup, FormControl, Validators } from "@angular/forms";


export var GipCompanyForm = new FormGroup({
    MID: new FormControl(),
    COMPANY: new FormControl('', [Validators.required, Validators.maxLength(250)]),
    STREET: new FormControl('', [Validators.required, Validators.maxLength(50)]),
    HOUSE_NUMBER: new FormControl('', [Validators.required, Validators.maxLength(50)]),
    ZIP_CODE: new FormControl('', [Validators.required, Validators.maxLength(50)]),
    CITY: new FormControl('', [Validators.required, Validators.maxLength(50)]),
    COUNTRY: new FormControl('', [Validators.required, Validators.maxLength(50)]),
    UNUSED: new FormControl(),
    PHONE: new FormControl('', [Validators.maxLength(50)]),
    FAX: new FormControl('', [Validators.maxLength(50)]),
    EMAIL: new FormControl('', [Validators.maxLength(50)]),
    CONTACT_PERSON: new FormControl('', [Validators.maxLength(50)]),
    DESCRIPTION: new FormControl('', [Validators.maxLength(250)]),
  });
  export class GipCompanyModel {
    MID: number;
    COMPANY: string;
    STREET: string;
    HOUSE_NUMBER: string;
    ZIP_CODE: string;
    CITY: string;
    COUNTRY: string;
    UNUSED: number;
    PHONE: string;
    FAX: string;
    EMAIL: string;
    CONTACT_PERSON: string;
    DESCRIPTION: string;

    fromFormGroupModel(formModel: FormGroup){
      this.MID = formModel.controls["MID"].value;
      this.COMPANY = formModel.controls["COMPANY"].value;
      this.STREET = formModel.controls["STREET"].value;
      this.HOUSE_NUMBER = formModel.controls["HOUSE_NUMBER"].value;
      this.ZIP_CODE = formModel.controls["ZIP_CODE"].value;
      this.CITY = formModel.controls["CITY"].value;
      this.COUNTRY = formModel.controls["COUNTRY"].value;
      this.UNUSED = formModel.controls["UNUSED"].value;
      this.PHONE = formModel.controls["PHONE"].value;
      this.FAX = formModel.controls["FAX"].value;
      this.EMAIL = formModel.controls["EMAIL"].value;
      this.CONTACT_PERSON = formModel.controls["CONTACT_PERSON"].value;
      this.DESCRIPTION = formModel.controls["DESCRIPTION"].value;
    }

    getUpdateMap() {
      return new Map ([
        ["MID", `${this.MID}`],
      
      ]);
    }
  }